const students = {
  students: "Students",
  definePassword: "Set a password",
  pendingActivation: "Pending activation",
  passwordRequired: "password required",
  student: "Student",
  studentDetail: "Student details",
  studentsList: "Students",
  newStudentsList: "New students",
  importStudents: "Import students",
  welcomeStudentPersonalHome: "Welcome to your dashboard",
  selectStudentInList: "Select an existing student from the list",
  studentNotActivated: "This student has not activated their account.",
  studentNotSubscribed: "This student has not subscribed yet.",
};

export default students;
